<template>
  <header class="app-header navbar">
    <button class="navbar-toggler mobile-sidebar-toggler d-lg-none" type="button" @click="mobileSidebarToggle">
      <span class="navbar-toggler-icon"></span>
    </button>
    <b-link class="navbar-brand" to="/dashboard">
    </b-link>
    <button class="navbar-toggler sidebar-toggler d-md-down-none mr-auto" type="button" @click="sidebarToggle">
      <span class="navbar-toggler-icon"></span>
    </button>
    <!-- <span style="font-size:16px;font-weight:600">DMC Report Admin</span>     -->
     <!-- 로그인 유저 이름 + click event -->
    <div class="user-profile-btn" v-on:click="openUserInfo">
      <i class="icon-user"></i>
      <span class="user-name">{{ $store.getters.getUserInfo.name }} 님</span>
    </div>
    <b-button class="mr-3 btn-pill btn-sm logout-btn" variant="outline-secondary" v-on:click="logoutSubmit">로그아웃</b-button>
    
    <!-- 비밀번호 변경 모달 -->
    <b-modal title="비밀번호 변경" size="md" v-model="passwordModal" centered hide-footer>
      <div class="mb-3">
        <div class="text-muted mb-4" style="font-size: 14px;">
          <i class="icon-info"></i> {{ $store.getters.getUserInfo.name }}님의 비밀번호를 변경합니다.
        </div>
        <PasswordChangeModal ref="pwModal" />
      </div>
      <div class="text-right border-top pt-3">
        <b-button variant="primary" @click="updatePassword">저장</b-button>
        <b-button variant="outline-secondary" @click="passwordModal = false">취소</b-button>
      </div>
    </b-modal>
    <!-- <button class="navbar-toggler aside-menu-toggler d-md-down-none" type="button" @click="asideToggle">
      <span class="navbar-toggler-icon"></span>
    </button> -->
    <!-- <a href="/" style="display:none" id="redirectLoginPage">Visit Home</a> -->
  </header>
</template>
<script>
const moment = require("moment");
import PasswordChangeModal from './PasswordChangeModal';
import swal from "sweetalert2";

export default {
  name: 'c-header',
  components: {
    PasswordChangeModal
  },
  data() {
    return {
      passwordModal: false
    }
  },
  methods: {
    sidebarToggle (e) {
      e.preventDefault()
      document.body.classList.toggle('sidebar-hidden')
    },
    sidebarMinimize (e) {
      e.preventDefault()
      document.body.classList.toggle('sidebar-minimized')
    },
    mobileSidebarToggle (e) {
      e.preventDefault()
      document.body.classList.toggle('sidebar-mobile-show')
    },
    asideToggle (e) {
      e.preventDefault()
      document.body.classList.toggle('aside-menu-hidden')
    },
    logoutSubmit(){
      this.$store.dispatch('LOGOUT');
      this.$router.push("/pages/login");
      // document.getElementById("redirectLoginPage").click();
    },
    openUserInfo(e){
      this.passwordModal = true;
      // 모달이 열린 후 폼 초기화
      this.$nextTick(() => {
        if(this.$refs.pwModal) {
          this.$refs.pwModal.resetForm();
        }
      });
    },
    async updatePassword() {
      // 1. 유효성 검사
      const check = await this.$refs.pwModal.validateForm();
      if (!check.valid) {
        swal.fire({
          type: 'warning',
          title: check.msg,
          showConfirmButton: false,
          timer: 1500
        });
        return;
      }

      // 2. 데이터 준비
      const newPassword = this.$refs.pwModal.getPassword();
      const currentUser = this.$store.getters.getUserInfo;
      // 사용자 정보 복사
      const submitData = JSON.parse(JSON.stringify(currentUser));
      submitData.password = newPassword;
      
      // 필요없는 필드가 있다면 제거하거나 api 스펙에 맞게 조정 (여기선 전체 전송)

      // 3. API 호출
      const token = sessionStorage.getItem("myToken");
      const param = encodeURI(JSON.stringify(submitData));
      const data = new FormData();
      data.append('objs', param);

      this.$http.post('/api/update/reportManager?access_token=' + token, data, null)
        .then((result) => {
          if(result.data.success == true){
            swal.fire({
              type: 'success',
              title: '비밀번호가 변경되었습니다.',
              showConfirmButton: false,
              timer: 1500
            });
            this.passwordModal = false;
            // 비밀번호 변경일 업데이트를 위해 사용자 정보 다시 불러오기 (선택)
             // this.$store.dispatch('GET_USER_INFO'); 
          }else{
            swal.fire({
              type: 'error',
              title: '비밀번호 변경 실패',
              text: result.data.message,
            });
          }
      })
    }
  },
  mounted: function() {
    let pwUpdateDate = this.$store.getters.getUserInfo.pw_update_date;
    let regDate = this.$store.getters.getUserInfo.reg_date;
    
    // 기준일 설정: pw_update_date가 있으면 사용, 없으면 reg_date 사용
    // 둘 다 없으면 체크 불가 (skip)
    let targetDate = pwUpdateDate ? pwUpdateDate : regDate;
    
    if (targetDate) {
      // 날짜 형식 변환 (YYYY-MM-DD 등 문자열일 수 있으므로 moment로 파싱)
      // 서버에서 어떤 포맷으로 오는지 확실치 않으나 moment는 웬만한건 다 처리함
      const lastChanged = moment(targetDate);
      const sixMonthsLater = lastChanged.add(6, 'months');
      const now = moment();
      
      // 6개월이 지났는지 비교
      if (now.isAfter(sixMonthsLater)) {
        // 모달 띄우기 전 알림
        swal.fire({
          type: 'info',
          title: '비밀번호 변경 알림',
          text: '비밀번호를 변경한 지 6개월이 지났습니다. 보안을 위해 비밀번호를 변경해주세요.',
          confirmButtonText: '변경하기'
        }).then((result) => {
          if (result.value) {
            this.openUserInfo();
          }
        });
      }
    }
  }
}
</script>

<style lang="scss">
.user-profile-btn {
  display: flex;
  align-items: center;
  cursor: pointer;
  padding: 6px 15px;
  margin-right: 10px;
  border-radius: 30px;
  transition: all 0.2s ease;
  color: #495057;

  &:hover {
    background-color: #f1f3f5;
    color: #20a8d8;
    transform: translateY(-1px);
    box-shadow: 0 2px 5px rgba(0,0,0,0.05);
  }

  i {
    font-size: 16px;
    margin-right: 8px;
  }

  .user-name {
    font-size: 15px;
    font-weight: 700;
  }
}

.tooltip {
  display: block !important;
  z-index: 10000;

  .tooltip-inner {
    background: black;
    color: white;
    border-radius: 16px;
    padding: 5px 10px 4px;
  }

  .tooltip-arrow {
    width: 0;
    height: 0;
    border-style: solid;
    position: absolute;
    margin: 5px;
    border-color: black;
    z-index: 1;
  }

  &[x-placement^="top"] {
    margin-bottom: 5px;

    .tooltip-arrow {
      border-width: 5px 5px 0 5px;
      border-left-color: transparent !important;
      border-right-color: transparent !important;
      border-bottom-color: transparent !important;
      bottom: -5px;
      left: calc(50% - 5px);
      margin-top: 0;
      margin-bottom: 0;
    }
  }

  &[x-placement^="bottom"] {
    margin-top: 5px;

    .tooltip-arrow {
      border-width: 0 5px 5px 5px;
      border-left-color: transparent !important;
      border-right-color: transparent !important;
      border-top-color: transparent !important;
      top: -5px;
      left: calc(50% - 5px);
      margin-top: 0;
      margin-bottom: 0;
    }
  }

  &[x-placement^="right"] {
    margin-left: 5px;

    .tooltip-arrow {
      border-width: 5px 5px 5px 0;
      border-left-color: transparent !important;
      border-top-color: transparent !important;
      border-bottom-color: transparent !important;
      left: -5px;
      top: calc(50% - 5px);
      margin-left: 0;
      margin-right: 0;
    }
  }

  &[x-placement^="left"] {
    margin-right: 5px;

    .tooltip-arrow {
      border-width: 5px 0 5px 5px;
      border-top-color: transparent !important;
      border-right-color: transparent !important;
      border-bottom-color: transparent !important;
      right: -5px;
      top: calc(50% - 5px);
      margin-left: 0;
      margin-right: 0;
    }
  }

  &[aria-hidden='true'] {
    visibility: hidden;
    opacity: 0;
    transition: opacity .15s, visibility .15s;
  }

  &[aria-hidden='false'] {
    visibility: visible;
    opacity: 1;
    transition: opacity .15s;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Header.vue